import { subMonths } from 'date-fns';

import { months } from '../config';

const EMPTY_MONTH = { income: 0, expenses: 0 };

const toMonthKey = date =>
	`${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;

const getMonthStats = (overview, currency, date) => {
	const monthKey = toMonthKey(date);
	const row = overview.find(
		item => item.currency === currency && item.month === monthKey,
	);
	if (!row) return EMPTY_MONTH;

	return {
		income: Number(row.income) || 0,
		expenses: Number(row.expenses) || 0,
	};
};

const compareMonths = (current, previous) => {
	if (!previous) return null;

	const percentage = ((current - previous) / Math.abs(previous)) * 100;
	return {
		percentage: Math.abs(percentage).toFixed(1),
		trend: percentage >= 0 ? 'up' : 'down',
	};
};

const getMonthName = (locale, date) => {
	const names = months[locale.split('-')[0]] ?? months.en;
	return names[date.getMonth()];
};

export const buildStatValues = ({ overview, currency, goal, intl, now }) => {
	const current = getMonthStats(overview, currency, now);
	const previous = getMonthStats(overview, currency, subMonths(now, 1));
	const monthName = getMonthName(intl.locale, now);
	const fromLastMonth = intl.formatMessage({ id: 'FinPathDashboardCartID11' });

	const toStatValue = (currentAmount, previousAmount) => {
		const comparison = compareMonths(currentAmount, previousAmount);
		return {
			amount: currentAmount.toFixed(2),
			change: comparison
				? `${comparison.percentage}% ${fromLastMonth}`
				: undefined,
			trend: comparison?.trend ?? 'up',
			monthName,
		};
	};

	return {
		income: toStatValue(current.income, previous.income),
		expenses: toStatValue(current.expenses, previous.expenses),
		balance: toStatValue(
			current.income - current.expenses,
			previous.income - previous.expenses,
		),
		goal: goal && {
			amount: goal.targetAmount.toFixed(2),
			currency: goal.currency,
		},
	};
};
